// Doğrudan cevap (A) + hesap. Hedef: dijital sadakat kartı nedir, kafelerde puan sistemi nasıl çalışır.
export default [
  {
    t: 'p',
    text: 'Dijital sadakat kartı, karton kaşe kartının telefondaki karşılığıdır. Müşteri bir uygulamaya ya da web sayfasına bir kez kayıt olur; her alışverişinde kasada kodunu söyler ya da gösterir, kazandığı puan veya ürün hesabına eklenir. Belirlenen hedefe ulaştığında ödül (bedava ürün ya da indirim) kullanıma açılır. Kartın kaybolması, kaşenin unutulması ya da sahte kaşe gibi sorunlar ortadan kalkar.',
  },
  {
    t: 'p',
    text: 'Bu yazıda kafelerde kullanılan puan ve ödül sistemlerini, hangisinin ne zaman uygun olduğunu ve bir ödülün işletmeye gerçekte neye mal olduğunu anlatıyoruz.',
  },
  { t: 'h2', text: 'Karton kart ile dijital kart arasındaki fark' },
  {
    t: 'table',
    head: ['', 'Karton kaşe kartı', 'Dijital sadakat kartı'],
    rows: [
      ['Kaybolma', 'Sık kaybolur, cüzdanda unutulur', 'Telefonda durur, kaybolmaz'],
      ['Kötüye kullanım', 'Kaşe kolayca taklit edilir', 'Her işlem kasada kayda geçer'],
      ['Müşteriyi tanıma', 'Kim olduğunu bilmezsiniz', 'Kaç kez geldiği, neyi sevdiği görülür'],
      ['Kampanya değişikliği', 'Yeni kart bastırmak gerekir', 'Panelden değişir'],
      ['Maliyet', 'Baskı maliyeti', 'Yazılım aboneliği'],
    ],
  },
  { t: 'h2', text: 'Kafelerde kullanılan sadakat sistemleri' },
  { t: 'h3', text: 'Ürün biriktirme (kafe kartı)' },
  {
    t: 'p',
    text: 'Karton kartın doğrudan dijital hâlidir: “9 kahve al, 10. bizden”. Müşterinin belirli bir üründen aldığı adet ziyaretler boyunca birikir, hedefe ulaşınca bedava ürün kazanır. Anlaşılması en kolay sistemdir ve kahve gibi sık alınan ürünlerde iyi çalışır.',
  },
  { t: 'h3', text: 'Ziyaret sayısı' },
  {
    t: 'p',
    text: 'Ürün ne olursa olsun, müşterinin yaptığı her alışveriş sayılır; belirli sayıya ulaşınca ödül verilir. Menüsü çeşitli olan ve müşterinin her seferinde farklı şey aldığı işletmeler için uygundur.',
  },
  { t: 'h3', text: 'Klasik puan' },
  {
    t: 'p',
    text: 'Her harcanan tutar için puan verilir (örneğin her 20 TL için 1 puan), belirli puana ulaşınca ödül kazanılır. Çok harcayan müşteriyi daha hızlı ödüllendirir. Karşılığında hesaplaması müşteri için biraz daha zordur; puan durumunun uygulamada görünmesi bu yüzden önemlidir.',
  },
  { t: 'h3', text: 'Anlık kampanyalar' },
  {
    t: 'p',
    text: 'Biriktirme gerektirmeyen, aynı siparişte uygulanan kampanyalardır: “aynı üründen 3 alana 1 bedava” ya da “500 TL üzeri siparişe tatlı hediye” gibi. Sadakatten çok sepet büyütmeye yöneliktir, ama sadakat programıyla birlikte kullanıldığında müşteriyi uygulamaya kayıt olmaya teşvik eder.',
  },
  { t: 'h2', text: 'Bir ödül işletmeye neye mal olur?' },
  {
    t: 'p',
    text: 'Ödülü değerlendirirken müşterinin gördüğü değer ile işletmenin katlandığı maliyeti ayırmak gerekir. Bedava verilen bir ürün, müşteriye menü fiyatıyla görünür; işletmeye ise yalnızca ürün maliyetine mal olur.',
  },
  {
    t: 'table',
    head: ['Program', 'Müşterinin gördüğü', 'İşletmeye maliyeti'],
    rows: [
      ['9 latte al, 10. bedava', 'Latte’de %10 indirim', 'Latte cirosunun yaklaşık %2,7’si'],
      ['Her 20 TL = 1 puan, 100 puanda latte', 'Harcamanın %7’si kadar hediye', 'Harcamanın yaklaşık %1,5’i'],
    ],
    caption: 'Latte menü fiyatı 140 TL (KDV hariç 127,27 TL), ürün maliyeti 30,60 TL varsayılmıştır.',
  },
  {
    t: 'p',
    text: 'Aradaki fark, bedava ürün ödülünü indirimden daha verimli kılar: aynı algılanan değeri daha düşük maliyetle verirsiniz. TL ya da yüzde indirim ise doğrudan cirodan düşer; bu tür ödülleri daha yüksek harcama eşiklerine bağlamak dengeyi korur. Ürün maliyetinin nasıl hesaplandığını [ürün maliyeti](/blog/urun-maliyeti-nasil-hesaplanir) yazısında anlattık.',
  },
  { t: 'h2', text: 'Programı kurarken dikkat edilecekler' },
  {
    t: 'list',
    items: [
      '**Hedef ulaşılabilir olsun.** Müşterinin ilk ödüle birkaç hafta içinde ulaşabilmesi, programa devam etmesini sağlar.',
      '**Kural tek cümleyle anlatılabilsin.** “Her 10 kahvede 1 kahve bizden” gibi. Kasada açıklaması uzun süren programlar kullanılmaz.',
      '**Ödülün bir kullanım süresi olsun.** Süresiz ödüller yıllarca birikip beklenmedik bir yük oluşturabilir.',
      '**Personel sormayı alışkanlık hâline getirsin.** “Sadakat kodunuz var mı?” sorusu sorulmadıkça program kendiliğinden yayılmaz.',
    ],
  },
  { t: 'h2', text: 'Tilki Otomasyon’da sadakat' },
  {
    t: 'p',
    text: 'Tilki’de kampanyalar panelin “Kampanyalar” ekranından tanımlanır; ürün biriktirme, ziyaret sayısı, klasik puan, aynı siparişte ürün adedi ve harcama eşiği tiplerinden biri seçilir. Ödül bedava ürün, TL ya da yüzde indirim olabilir. Müşteri, Tilki Sadakat uygulamasına (web, App Store ve Google Play) kayıt olup profilindeki kodu kasada söyler; siz hesap özetinde “Puan Kazan” ile kampanyayı işlersiniz, müşteri de ödüllerini uygulamada görür.',
  },
  {
    t: 'guide',
    image: '31-puan-kazan',
    alt: 'Hesap özetinde müşteri koduyla puan kazandırma ekranı',
    caption: 'Puan kazandırma: müşteri koduyla doğrulama ve koşulu sağlanan kampanya.',
  },
  {
    t: 'guide',
    image: '30-sadakat-odullerim',
    alt: 'Tilki Sadakat uygulamasında müşterinin ödüllerim ekranı',
    caption: 'Müşteri tarafı: kazanılan ödüller uygulamada görünür.',
  },
  {
    t: 'p',
    text: 'Tüm adımlar ekran görüntüleriyle [rehberin kampanya ve sadakat bölümünde](/nasil-kullanilir#sadakat). Programın müşteri tarafında nasıl yaygınlaştırılacağını ise [kafe müşteri sadakati nasıl artırılır](/blog/kafe-musteri-sadakati-nasil-artirilir) yazısında anlattık.',
  },
  {
    t: 'cta',
    title: 'Sadakat programınızı birlikte kuralım',
    text: 'Ücretsiz demo talep edin; işletmenize uygun kampanya tipini seçip ilk programı birlikte tanımlayalım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Dijital sadakat kartı için müşterinin uygulama indirmesi şart mı?',
    a: 'Sisteme göre değişir. Tilki’de müşteri isterse App Store ya da Google Play’deki Tilki Sadakat uygulamasını indirir, istemezse sadakat.tilkiotomasyon.com adresinden tarayıcıyla kayıt olur.',
  },
  {
    q: 'Puan sistemi mi, kaşe kartı mantığı mı daha iyi?',
    a: 'Müşterileriniz çoğunlukla aynı ürünü alıyorsa (sabah kahvesi gibi) ürün biriktirme daha anlaşılırdır. Sepet tutarı müşteriden müşteriye çok değişiyorsa klasik puan sistemi, çok harcayanı daha adil ödüllendirir.',
  },
  {
    q: 'Sadakat programı birden fazla şubede geçerli olabilir mi?',
    a: 'Evet. Tilki’de kampanya şirket düzeyinde tanımlanır ve hangi şubelerde geçerli olacağı seçilir; müşteri seçilen şubelerin hepsinde puan kazanıp ödülünü kullanabilir.',
  },
];
